import { render } from "./EnglishRequiredTooltip.vue?vue&type=template&id=6134a8c6"
import script from "./EnglishRequiredTooltip.vue?vue&type=script&lang=js"
export * from "./EnglishRequiredTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
